import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

function TabItem({ isActive, title, link, className, handleClick, noTranslation }) {
  return (
    <li className={`nav-item cursor-pointer ${className ? className : ''}`}>
      {!link ? (
        <span
          className={`border-0 nav-link ${
            isActive ? ' border-primary active' : 'text-muted text-secondary'
          }`}
          variant="link"
          onClick={handleClick}>
          {noTranslation ? title : <FormattedMessage id={title} />}
        </span>
      ) : (
        <Link
          to={link ? link : '#'}
          className={`nav-link   ${
            isActive ? ' border-primary active' : 'text-muted text-secondary'
          }`}>
          {noTranslation ? title : <FormattedMessage id={title} />}
        </Link>
      )}
    </li>
  );
}

export default TabItem;
